import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';

// Components
import { LoadingOutlined } from '@ant-design/icons';
import { Portal, Spin } from 'top-component-library';

// Utils
import { disableScroll, enableScroll } from 'utils/Scroll';

import { Backdrop, Container, Content, Text } from './styles';

/**
 * Overlays the checkout modal/page with a blurred background and loading spinner.
 * Should be guarded by checking `editor.addingItem === true` before rendering.
 */
function AddItemProcessing() {
  const textRef = useRef<HTMLDivElement>(null);

  // Prevent scrolling and disable all page interactivity while checkout is processing.
  useEffect(() => {
    const handleKeyup = (event: KeyboardEvent): void => {
      // Keeps the user from tabbing to anything other than the spinner text.
      if (event.code === 'Tab') {
        textRef.current?.focus();
      }
    };

    document.addEventListener('keyup', handleKeyup);
    textRef.current?.focus();
    disableScroll();

    return () => {
      document.removeEventListener('keyup', handleKeyup);
      enableScroll();
    };
  }, []);

  return (
    <Portal id="add-item-processing">
      <Container>
        <Backdrop />
        <Content>
          <Spin indicator={<LoadingOutlined spin />} size="large" />
          <Text ref={textRef} tabIndex={0}>
            Adding to cart
          </Text>
        </Content>
      </Container>
    </Portal>
  );
}

export default observer(AddItemProcessing);
